import { ColaboradoresPrograma } from './colaboradores-programa';
import { ComposicaoRhPrograma } from './composicao-rh-programa';
import { ContasCentrosCusto } from './contas-centros-custo';
import { MateriaisPrograma } from './materiais-programa';
import { Objetivo } from './objetivo';
import { ParceriasPrograma } from './parcerias-programa';
import { Unidade } from './unidade';

export class Programa {
	id: number;
	codigoPrograma: string;
	nome: string;
	descricao: string;
	restricao:boolean;
	dataInicio: Date;
	dataFim: Date;
	idCoordenador: number;
	faixaEtariaFim: number;
	faixaEtariaInicio: number;
	objetivo: Objetivo;
	usuarioAlteracao: number;
	publicoAlvo:string;
	justificativa:string;
	objetivoGeral:string;
	objetivoEspecifico:string;
	unidades:Unidade[];
	colaboradoresPrograma:ColaboradoresPrograma[];
	parceriasPrograma:ParceriasPrograma[];
	composicaoRhPrograma:ComposicaoRhPrograma[];
	materiaisPrograma:MateriaisPrograma[];
	contasCentrosCusto:ContasCentrosCusto[];
}